"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyDashboardCollageDelete = void 0;
exports.dashboardCollageDeleteSetMock = dashboardCollageDeleteSetMock;
exports.dashboardCollageDelete = dashboardCollageDelete;
exports.useMutationDashboardCollageDelete = useMutationDashboardCollageDelete;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function dashboardCollageDeleteSetMock(mock) {
    setMock = mock;
}
async function dashboardCollageDelete(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-dashboard-service/v1/dashboard/collage/${params.id}`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    if ((params.forceStatusCheck) && (await (0, is_down_1.wolfDashboardServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'DELETE', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyDashboardCollageDelete = 'wolf-dashboard-service:dashboardCollageDelete:delete';
function useMutationDashboardCollageDelete(mutationOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    return reactQuery.useMutation(mutationFn, Object.assign({ mutationKey: exports.useKeyDashboardCollageDelete }, mutationOptions));
}
function mutationFn({ params }) {
    const promise = dashboardCollageDelete(params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=dashboard-collage-delete.js.map